import { UiModule } from "@topyourthree/ui";
import { ModalModule } from "@topyourthree/ui/modal";
import { AppModalsModule } from "app/app-modals.module";
import * as i0 from "@angular/core";
export class CompatModalsModule {
}
CompatModalsModule.ɵfac = function CompatModalsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CompatModalsModule)(); };
CompatModalsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CompatModalsModule });
CompatModalsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [UiModule, ModalModule, AppModalsModule] });
